/**************************************************************************************************/
/*   File: /src/app/shared/models/external.user.ts                                                */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Tuesday February 19th 2019                                                     */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
/**
 * The external user data
 */
export class ExternalUser {
    /**
     * The surname of the user
     */
    cognome: string;
    /**
     * The user email
     */
    email: string;
    /**
     * The external user id
     */
    externalUserId: number;
    /**
     * The iso code
     */
    isoCode: string;
    /**
     * The name of the user
     */
    nome: string;
    /**
     * The username
     */
    username: string;
}